'use strict'
import vm from '@/main'
// import { url } from 'inspector';
const loginStore = {}

/* @usage : store state data shcema
            this.$store.state.login  */
loginStore.state = {
  userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {
    'userid': '',
    'employeeZhName': '',
    'employeeEnName': '',
    'companyId':'',
    'companyName':'',
  },

}

/* @usage : unit operation
   this.$store.commit('USER_LOGIN') */
loginStore.mutations = {
  'USER_LOGIN' (state, userInfo, keys) {
    if (keys && keys.length > 0) {
      keys.forEach((key) => {
        state.userInfo[key] = userInfo[key]
      })
    } else {
      state.userInfo = userInfo
    }
    // vm.$cookie.set('user', state.userInfo, 7)
    sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo))

    let url = location.href;

    if(url.indexOf('bysiot')>0){
        document.domain = 'bysiot.com';
        sessionStorage.setItem('userInfo', JSON.stringify(state.userInfo))
        localStorage.setItem('userInfo', JSON.stringify(state.userInfo))

    }
   
  },
  'USER_LOGOUT' (state) {
    state.userInfo = {
      'userid': '',
      'employeeZhName': '',
      'employeeEnName': '',
      'companyId':'',
      'companyName':'',
      'sceneId':'',
       'roleList':''
    }
    // vm.$cookie.delete('user')
    sessionStorage.removeItem('userInfo')
    vm.$router.push('/login')
  }
}

/* @usage : based on state ,  return state's length or filter state data */
loginStore.getters = {
}

/* @usage : basic the operation for view component , this.$store.dispatch('USER_LOGIN') */
loginStore.actions = {
  'USER_LOGIN_ACTION' ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      commit('USER_LOGIN', obj)
      resolve()
    })
  },
  'USER_LOGOUT_ACTION' ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('USER_LOGOUT')
      resolve()
    })
  }
}

export default loginStore



// WEBPACK FOOTER //
// ./src/pages/auth/login.store.js